export type Pair = {
  value: string;
  label: string;
  pipValue: number;
  pipSize: number;
  price: number;
  unitValue: number;
};

export const PAIRS: Pair[] = [
  { value: 'EURUSD', label: 'EUR/USD', pipValue: 10, pipSize: 0.0001, price: 1.0845, unitValue: 108450 },
  { value: 'GBPUSD', label: 'GBP/USD', pipValue: 10, pipSize: 0.0001, price: 1.268, unitValue: 126800 },
  { value: 'AUDUSD', label: 'AUD/USD', pipValue: 10, pipSize: 0.0001, price: 0.652, unitValue: 65200 },
  { value: 'USDJPY', label: 'USD/JPY', pipValue: 6.53, pipSize: 0.01, price: 153.2, unitValue: 100000 },
  { value: 'USDCAD', label: 'USD/CAD', pipValue: 7.31, pipSize: 0.0001, price: 1.368, unitValue: 100000 },
];

export const LEVERAGES = [
  { value: '50', label: '1:50' },
  { value: '100', label: '1:100' },
  { value: '200', label: '1:200' },
  { value: '500', label: '1:500' },
  { value: '1000', label: '1:1000' },
];